import React from "react";
import { FaUsers } from "react-icons/fa";

const Gatilho = ({ notifyColor = "#51a197", selected, setSelected, isMobile = false, onProximo }) => {
  return (
    <div style={{ padding: 12 }}>
      <div
        onClick={() => setSelected && setSelected("Encher Grupo da Campanha")}
        role="button"
        tabIndex={0}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: 12,
          borderRadius: 10,
          border: `1px solid ${notifyColor}`,
          background: selected === "Encher Grupo da Campanha" ? notifyColor : "#fff",
          color: selected === "Encher Grupo da Campanha" ? "#fff" : "#333",
          cursor: "pointer",
          width: "100%",
          maxWidth: 420,
        }}
      >
        <input
          type="radio"
          name="gatilho"
          checked={selected === "Encher Grupo da Campanha"}
          onChange={() => setSelected && setSelected("Encher Grupo da Campanha")}
          style={{ width: 18, height: 18, accentColor: notifyColor }}
        />

        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <FaUsers style={{ fontSize: 18, color: selected === "Encher Grupo da Campanha" ? "#fff" : notifyColor }} />
          <div style={{ fontWeight: 600 }}>Encher Grupo da Campanha</div>
        </div>
      </div>

      {isMobile && (
        <div style={{ marginTop: 12, display: "flex", justifyContent: "center", width: "100%" }}>
          <button
            onClick={() => onProximo && onProximo()}
            disabled={!selected}
            style={{
              background: !selected ? "#ccc" : notifyColor,
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "12px 22px",
              fontWeight: "700",
              fontSize: 18,
              cursor: !selected ? "not-allowed" : "pointer",
              opacity: !selected ? 0.6 : 1,
              transition: "background 0.2s",
              width: "100%",
              maxWidth: 420,
            }}
          >
            Próximo
          </button>
        </div>
      )}
    </div>
  );
};

export default Gatilho;
